import { useContext, useEffect } from 'react';
import { useDispatch } from 'store/hooks';
import type { User } from 'api';
import useOnlyOnce from 'hooks/use-only-once';
import { verifyAuth } from 'core/auth/actions';
import { useCurrentUserSelector, useAuthIsVerified } from 'core/auth/hooks';
import { I18NContext } from 'ui/i18n/provider';

export function useValidateAuth() {
  const dispatch = useDispatch();
  const { currentUser, loading, error } = useCurrentUserSelector();
  const authIsVerified = useAuthIsVerified();

  useOnlyOnce(() => {
    dispatch(verifyAuth());
  });

  return { authIsVerified, currentUser, loading, error };
}

/**
 * No-op hook for backward compatibility.
 * Session cookies are managed automatically by the browser, no sync needed.
 */
export function useAuthTokenSync(): void {
  // Session cookies are httpOnly and managed by the browser
  // No localStorage sync needed
}

export function useInitUserLanguage(me: User | null) {
  const { changeLocale } = useContext(I18NContext);

  const userLanguage = (me && me.language && me.language.split('-')[0].toLowerCase()) || undefined;

  useEffect(() => {
    changeLocale(userLanguage, { user: true });
  }, [userLanguage, changeLocale]);
}
